import { render, staticRenderFns } from "./CustomTagsInput.vue?vue&type=template&id=38e9ae79&scoped=true&"
import script from "./CustomTagsInput.vue?vue&type=script&lang=js&"
export * from "./CustomTagsInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomTagsInput.vue?vue&type=style&index=0&id=38e9ae79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e9ae79",
  null
  
)

export default component.exports